import * as React from "react"
import {
  ChakraProvider,
  Box,
  Heading,
  VStack,
  Grid,
  Icon,
  Flex,
  theme,
} from "@chakra-ui/react"
import { FiGift } from "react-icons/fi"
import { ColorModeSwitcher } from "./ColorModeSwitcher"
import { Main } from "./Main"
import { InfoModalButton } from "./InfoModalButton"

// good light bg: bgGradient="linear(teal.100, cyan.100)"

export const App = () => (
  <ChakraProvider theme={theme}>
    <Box textAlign="center" fontSize="xl">
      <Grid minH="100vh" p={3}>
        <Flex w="100%" justifySelf="flex-end" justify="space-between">
          {/*@TODO this is dumb, but here to ensure box with heading is centered*/}
          <Box w="40px" mr={2}></Box>
          <Box>
            <Heading
              as="h1"
              bgGradient="linear(to-r, #7928CA 0%, #FF0080 75%, #7928CA 100%)"
              fontSize="3xl"
              bgClip="text"
              _hover={{
                backgroundPosition: -150,
              }}
              sx={{
                backgroundSize: 150,
                transition: "background 0.25s ease-in-out",
              }}
            >
              PLYGRND
            </Heading>
            <Icon as={FiGift} mt={4} fontSize="3xl" />
          </Box>
          <Box>
            <InfoModalButton />
            <ColorModeSwitcher />
          </Box>
        </Flex>
        <VStack spacing={10} px={[4, 8, 16]} maxWidth="1400" mx="auto">
          <Main />
        </VStack>
      </Grid>
    </Box>
  </ChakraProvider>
)
